import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* products(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/product/?offset=0&limit=' + actions.limit : config.credentials.url + '/product/' + actions.query;
        const dataProducts = yield call(apiCall, 'get', url, requestOptions)

        if (actions.view === "delete") {
            yield put({ type: "PRODUCTS_RESPONSE", response: dataProducts, view: actions.view, responseDelete: actions.responseDelete, id: actions.id })
        } else {
            yield put({ type: "PRODUCTS_RESPONSE", response: dataProducts, view: actions.view })
        }
    } catch (error) {
        yield put({ type: "PRODUCTS_RESPONSE", response: error, view: actions.view })
    }
}


function* setProductCode(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
        const response = yield call(apiCall, 'PATCH', config.credentials.url + '/product/' + actions.id + '/', requestOptions)
        yield put({ type: "RESPONSE_PRODUCTCODE_CHANGED", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_PRODUCTCODE_CHANGED", value: error })
    }
}

function* filterRatesList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        let url = (actions.query === null) ? config.credentials.url + '/rate_selection_filter/' : config.credentials.url + '/rate_selection_filter/' + actions.query;
        const response = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "FILTER_RATES_RESPONSE", response: response, rateType: actions.rateType })
    } catch (error) {
        yield put({ type: "FILTER_RATES_RESPONSE", response: error, rateType: actions.rateType })
    }
}

function* productsLongName(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        let url = (actions.query === null) ? config.credentials.url + '/product/?only_long_name=true&offset=0&limit=' + actions.limit : config.credentials.url + '/product/' + actions.query;
        const dataProducts = yield call(apiCall, 'get', url, requestOptions)

        if (actions.view === "delete") {
            yield put({ type: "PRODUCTS_RESPONSE", response: dataProducts, view: actions.view, responseDelete: actions.responseDelete, id: actions.id })
        } else {
            yield put({ type: "PRODUCTS_RESPONSE", response: dataProducts, view: actions.view })
        }
    } catch (error) {
        yield put({ type: "PRODUCTS_RESPONSE", response: error, view: actions.view })
    }
}

function* remove(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };


        const response = yield call(apiCall, 'delete', config.credentials.url + '/product/' + actions.id + '/', requestOptions)


        actions.view = "delete";
        actions.responseDelete = response;
        actions.query = null;
        yield products(actions);

    } catch (error) {
        yield put({ type: "PRODUCT_RESPONSE_REMOVE", value: error })
    }
}

function* productsReducida(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/product_name_id/?offset=0&limit=' + actions.limit : config.credentials.url + '/product_name_id/' + actions.query

        const dataProducts = yield call(apiCall, 'get', url, requestOptions)

        if (actions.view === "delete") {
            yield put({ type: "PRODUCTS_RESPONSE_REDUCIDA", response: dataProducts, view: actions.view, responseDelete: actions.responseDelete, id: actions.id })
        } else {
            yield put({ type: "PRODUCTS_RESPONSE_REDUCIDA", response: dataProducts, view: actions.view })
        }
    } catch (error) {
        yield put({ type: "PRODUCTS_RESPONSE_REDUCIDA", response: error, view: actions.view })
    }
}

function* validListDuplicateCodeProduct(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        let url = config.credentials.url + '/product/?limit=10000&product_code=' + actions.query;
        const response = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "PRODUCTS_DUPLICATE_LIST_RESPONSE", response: response, view: actions.view })
    } catch (error) {
        yield put({ type: "PRODUCTS_DUPLICATE_LIST_RESPONSE", response: error, view: actions.view })
    }
}

function* sortedProducts(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        let url = config.credentials.url + "/api/order_products/?order_key=" + actions.orderKey
        const dataProducts = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "SORTED_PRODUCTS_RESPONSE", response: dataProducts })
    } catch (error) {
        yield put({ type: "SORTED_PRODUCTS_RESPONSE", response: error })
    }
}

function* sortProducts(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        let url = config.credentials.url + "/api/order_products/"
        const dataProducts = yield call(apiCall, 'post', url, requestOptions)

        yield put({ type: "SORTED_PRODUCTS_RESPONSE", response: dataProducts })
    } catch (error) {
        yield put({ type: "SORTED_PRODUCTS_RESPONSE", response: error })
    }
}

function* typologies(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        let url = (actions.query === null) ? config.credentials.url + '/typology/?offset=0&limit=' + actions.limit : config.credentials.url + '/typology/' + actions.query;
        const dataTypologies = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "TYPOLOGIES_RESPONSE", response: dataTypologies })
    } catch (error) {
        yield put({ type: "TYPOLOGIES_RESPONSE", response: error })
    }
}

function* addTypology(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/typology/', requestOptions);

        yield put({ type: "TYPOLOGY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TYPOLOGY_RESPONSE", value: error })
    }
}

function* editTypology(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/typology/' + actions.id + '/', requestOptions)

        yield put({ type: "TYPOLOGY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TYPOLOGY_RESPONSE", value: error })
    }
}

function* removeTypology(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/typology/' + actions.data + '/', requestOptions)

        yield put({ type: "TYPOLOGY_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "TYPOLOGY_RESPONSE", value: error })
    }
}

export function* getProductsList() {
    yield takeEvery("GET_PRODUCTS", products)
}

export function* getProductsListLongName() {
    yield takeEvery("GET_PRODUCTS_LONG_NAME", productsLongName)
}

export function* removeProduct() {
    yield takeEvery("REMOVE_PRODUCT", remove)
}

export function* getProductsListReducida() {
    yield takeEvery("GET_PRODUCTS_REDUCIDA", productsReducida)
}

export function* getSortedProductsList() {
    yield takeEvery("GET_SORTED_PRODUCTS", sortedProducts)
}

export function* sortProductsList() {
    yield takeEvery("SORT_PRODUCTS", sortProducts)
}

export function* getTypologiesList() {
    yield takeEvery("GET_TYPOLOGY_PRODUCTS", typologies)
}

export function* addTypologyProducts() {
    yield takeEvery("ADD_TYPOLOGY_PRODUCTS", addTypology)
}

export function* editTypologyProducts() {
    yield takeEvery("EDIT_TYPOLOGY_PRODUCTS", editTypology)
}

export function* deleteTypologyProducts() {
    yield takeEvery("REMOVE_TYPOLOGY_PRODUCTS", removeTypology)
}
export function* getValidListDuplicateCodeProduct() {
    yield takeEvery("VALID_DUPLICATE_CODE_PRODUCT", validListDuplicateCodeProduct)
}

export function* getFilterRateList() {
    yield takeEvery("GET_FILTER_RATES", filterRatesList)
}

export function* sagaSetProductCode() {
    yield takeEvery("SET_PRODUCT_CODE", setProductCode)
}